<template>
  <div class="page_content explore_entity_inside program v_22_1" aria-label="Program Guide Career Prospects">

      <div class="row page-heading">
          <div class="col-xl-8 col-lg-8 col-md-8 col-sm-6 col-6 input module_heading">
            <span class="module_icon  icon-list"></span>
            <template v-if="formattedProgramGuide && formattedProgramGuide.title">
              <program-guide-title :program-guide="formattedProgramGuide"></program-guide-title>
            </template>
          </div>

          <template v-if="isWidget">
            <div class="col-xl-8 col-lg-8 col-md-8 col-sm-6 col-6 btn_container" :id="'creditProgressPopup_' + programGuide.uuid">
              <b-btn style="width: 225px; padding: 0;" @click="calculateCreditProgressClicked(programGuide)">
                <b-progress :max="progress.total" height="30px" style="cursor: pointer;" show-value>
                  <b-progress-bar :value="Number(selected)" style="background-color: #532a6e;"></b-progress-bar>
                  <b-progress-bar :value="progress.completed" style="background-color: #508002;"></b-progress-bar>
                  <b-progress-bar :value="progress.notPlanned - selected" style="background-color: #cf7908;"></b-progress-bar>
                </b-progress>
              </b-btn>
            </div>
          </template>
          <template v-else>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6 btn_container" v-if="showBackToResultButton">
              <b-btn @click.stop.prevent="returnToClicked" :aria-label="deCamelCase()">
                <span class="btn_ic ic-back"></span>
                <span class="btn_txt"> {{ deCamelCase() }} </span>
              </b-btn>
              <span v-if="showAddCompletedCoursesOnResult">
                <b-button @click="addCompletedCourses" aria-label="add completed courses">Add Completed Courses</b-button>
              </span>
              <span class="lnk_req_credit"
                v-if="showCalculateRequiredCredit && isStudentLogin && planningStream" :id="'creditProgressPopup_' + programGuide.uuid"
                @click="calculateCreditProgressClicked(programGuide)">
                <template v-if="isShowCourseProgressEnabled">
                  <template v-if="showTransferredCoursesCreditProgress">
                    <div style="border: 1px solid #157099; margin: -3px -15px; font-size: 18px;">
                      <span style="font-size: 15px; padding: 0 10px 0 10px; color: #8cbc3f;">saved {{progress.transferredCourses}} out of {{progress.totalCourses}} courses</span>
                    </div>
                  </template>
                  <template v-else>
                    <b-btn style="width: 225px; padding: 0;">
                      <b-progress :max="progress.totalCourses" height="27px" style="cursor: pointer; margin-top: -4px;" show-value>
                        <b-progress-bar :value="progress.transferredCourses" :precision="setPrecision(progress.transferredCourses)" style="background-color: #57b6e6;"></b-progress-bar>
                        <b-progress-bar :value="progress.completedCourses" :precision="setPrecision(progress.completedCourses)" style="background-color: #508002;"></b-progress-bar>
                        <b-progress-bar :value="progress.inProgressCourses" :precision="setPrecision(progress.inProgressCourses)" style="background-color: #9ec758;"></b-progress-bar>
                        <b-progress-bar :value="progress.notStartedCourses" :precision="setPrecision(progress.notStartedCourses)" style="background-color: #f5b318;"></b-progress-bar>
                        <b-progress-bar :value="progress.notPlannedCourses" :precision="setPrecision(progress.notPlannedCourses)" style="background-color: #cf7908;"></b-progress-bar>
                      </b-progress>
                    </b-btn>
                  </template>
                </template>
                <template v-else>
                  <template v-if="showTransferredCoursesCreditProgress">
                    <div style="border: 1px solid #157099; margin: -3px -15px; font-size: 18px;">
                      <span style="font-size: 15px; padding: 0 10px 0 10px; color: #8cbc3f;">saved {{progress.transfered}} out of {{progress.total}} credits</span>
                    </div>
                  </template>
                  <template v-else>
                    <b-btn style="width: 225px; padding: 0;">
                      <b-progress :max="progress.total" height="27px" style="cursor: pointer; margin-top: -4px;" show-value>
                        <b-progress-bar :value="progress.transfered" :precision="setPrecision(progress.transfered)" style="background-color: #57b6e6;"></b-progress-bar>
                        <b-progress-bar :value="progress.completed" :precision="setPrecision(progress.completed)" style="background-color: #508002;"></b-progress-bar>
                        <b-progress-bar :value="progress.inProgress" :precision="setPrecision(progress.inProgress)" style="background-color: #9ec758;"></b-progress-bar>
                        <b-progress-bar :value="progress.notStarted" :precision="setPrecision(progress.notStarted)" style="background-color: #f5b318;"></b-progress-bar>
                        <b-progress-bar :value="progress.notPlanned" :precision="setPrecision(progress.notPlanned)" style="background-color: #cf7908;"></b-progress-bar>
                      </b-progress>
                    </b-btn>
                  </template>
                </template>
              </span>
            </div>
          </template>
      </div>


      <div class="page_content_container" id="careerProspectsPgContent">

        <div v-if="formattedProgramGuide && formattedProgramGuide.title">
            <program-guide-menu
                :cipCode="formattedProgramGuide.cipCode"
                :programGuideCode="formattedProgramGuide.code"
                :type="formattedProgramGuide.type"
                :returnTo="returnTo"
                :active="'careerProspects'"
                :isWidget="isWidget"
                :selected="selected">
            </program-guide-menu>
        </div>

        <div class="row pg_content">

            <div v-if="formattedProgramGuide && formattedProgramGuide.title" class="col-xl-12 col-lg-12 col-md-12 col-sm-12 content_mid_panel">
              <program-guide-career-prospects-detail :cipCode="cipCode" :programGuideCode="programGuideCode" :isShowLess="isShowLess"></program-guide-career-prospects-detail>
            </div>

            <!--<div class="col-xl-3 col-lg-4 col-md-4 col-sm-12 content_rgt_panel">

              <div v-if="formattedProgramGuide && formattedProgramGuide.cipCode">
                  <program-guide-summary></program-guide-summary>

                  <program-guide-recommendations
                      :cipCode="formattedProgramGuide.cipCode"
                      :programGuideCode="formattedProgramGuide.code"
                      :type="formattedProgramGuide.type"
                      :returnTo="returnTo"
                      :showBookmarks="true">
                  </program-guide-recommendations>
              </div>

          </div>--> <!-- .content_rgt_panel -->

          </div> <!-- .pg_content -->
          <template v-if="showCreditProgressPopup">
            <explore-program-credit-progress
                :title="selectedProgramGuide.title"
                :stream-id="planningStream.uuid"
                :program-id="selectedProgramGuide.uuid"
                :credit-progress-target-id="creditProgressTargetId"
                :is-widget="isWidget"
                :selected="Number(selected)">
            </explore-program-credit-progress>
          </template>

    </div> <!-- .page_content_container -->


    <div class="loading-spinner">
        <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
            <div class="text-center" style="color: #FFF">
              <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
            </div>
        </b-modal>
      </div>

      <div class="modal_popup_container">
        <b-modal id="userVerificationPopup" ref="newFormModal" centered hide-footer class="usr_verification_popup" no-close-on-backdrop>
          <div slot="modal-header" class="header-section">
            <div class="head_txt">
              Create Your Account To Explore More
            </div>
            <div class="btn_container">
              <button class="btn_close" aria-label="close" @click="closeModalBox">
              <span class="ic-close"></span>
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-1 lft_col"></div>
            <div class="col-5 content_col">
              <p>Your institution has made the Pragya Explore app available to you for free.</p>
              <p>Your Data is completely secure. Read our <a v-if="institution.privacyPolicyLink" :href="institution.privacyPolicyLink" target="_blank">Privacy Policy</a> <a v-if="!institution.privacyPolicyLink" href="https://site.pragyasystems.com/privacy-policy/" target="_blank">Privacy Policy</a></p>
              <p v-if="isShowPhoneOnCreateAccountModalEnabled">{{showPhoneOnCreateAccountModalLabel}}</p>
            </div>
            <div class="col-5 content_col">
              <p v-if="newProspectError" class="text-danger">{{newProspectError}}</p>
              <div class="row page_fld_section">
                <div class="col-12">
                  <div class="fld-label" id="firstName">First Name <sup>*</sup></div>
                </div>
                <div class="col-12">
                  <b-form-input type="text" v-model.trim="newForm.firstName" placeholder="First Name">
                  </b-form-input>
                </div>
              </div>
              <div class="row page_fld_section">
                <div class="col-12">
                  <div class="fld-label" id="lastName">Last Name <sup>*</sup></div>
                </div>
                <div class="col-12">
                  <b-form-input type="text" v-model.trim="newForm.lastName" placeholder="Last Name">
                  </b-form-input>
                </div>
              </div>
              <div class="row page_fld_section">
                <div class="col-12">
                  <div class="fld-label" id="lastName">Password <sup>*</sup></div>
                </div>
                <div class="col-12">
                  <b-form-input type="password" v-model.trim="newForm.password" placeholder="Password">
                  </b-form-input>
                </div>
              </div>
              <div class="row page_fld_section">
                <div class="col-12">
                  <div class="fld-label" id="lastName">Confirm Password <sup>*</sup></div>
                </div>
                <div class="col-12">
                  <b-form-input type="password" v-model.trim="repassword" placeholder="Confirm Password">
                  </b-form-input>
                </div>
              </div>
              <div class="row page_fld_section" v-if="isShowPhoneOnCreateAccountModalEnabled">
                <div class="col-12">
                  <div class="fld-label" id="lastName">Phone Number <sup v-if="isPhoneRequiredOnCreateAccountModal">*</sup></div>
                </div>
                <div class="col-12">
                  <b-form-input type="text" v-model.trim="newForm.primaryPhoneNumber" placeholder="Phone Number">
                  </b-form-input>
                </div>
              </div>
              <div class="row page_fld_section">
                <div class="col-12">
                  <div class="fld-label" id="lastName">By clicking on Create Account you are accepting our <a v-if="institution.privacyPolicyLink" :href="institution.privacyPolicyLink" target="_blank">Privacy Policy</a> <a v-if="!institution.privacyPolicyLink" href="https://site.pragyasystems.com/privacy-policy/" target="_blank">Privacy Policy</a> & <a href="https://site.pragyasystems.com/terms-of-use/" target="_blank">Terms of Use</a></div>
                </div>
              </div>
              <div class="row popup_btn_container">
                <div class="col-6 pragya_login_lnk">
                </div>
                <div class="col-6 popup_btn">
                  <b-button size="lg" @click="registerProspectiveStudent()"aria-label="verify">Create Account</b-button>
                </div>
              </div>
            </div>
            <div class="col-1 rgt_col"></div>
          </div>
        </b-modal>
      </div>


  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import ProgramGuideMenu from './ProgramGuideMenu'
import ProgramGuideTitle from './ProgramGuideTitle'
import ProgramGuideRecommendations from './ProgramGuideRecommendations'
// import ProgramGuideSummary from './ProgramGuideSummary'
import ProgramGuideCareerProspectsDetail from './ProgramGuideCareerProspectsDetail'
import ExploreProgramCreditProgress from '../../explore/components/ExploreProgramCreditProgress'
import _ from 'lodash'
import { StorageFactory } from '../../../storageFactory'

export const localStore = StorageFactory(() => localStorage)

export default {
  name: 'program-guide-career-prospects',
  props: ['cipCode', 'programGuideCode', 'type', 'returnTo', 'showBackToResultButton', 'isWidget', 'selected', 'loadDataFromServer'],
  components: {
    ProgramGuideMenu,
    ProgramGuideTitle,
    ProgramGuideRecommendations,
    // ProgramGuideSummary,
    ProgramGuideCareerProspectsDetail,
    ExploreProgramCreditProgress
  },
  data: () => {
    return {
      RECOMMENDATION_TERM_LIMIT: 5,
      selectedState: '',
      selectedMetroArea: '',
      selectedCounty: '',
      disableSelectState: false,
      disableSelectMetroArea: false,
      disableSelectCounty: false,
      targetOccupationItems: [],
      topCompaniesItems: [],
      topSkillsFields: ['Skill', 'Postings with Skill'],
      topSkillsItems: [],
      DEFAULT_RETURN_TO: 'exploreProgramGuideResults',
      EXPLORE_RESULTS: 'exploreProgramGuideResults',
      isShowLess: false,
      progress: {},
      selectedProgramGuide: null,
      creditProgressTargetId: '',
      showCreditProgressPopup: false,
      repassword: '',
      newForm: {
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        primaryPhoneNumber: ''
      },
      newProspectError: '',
      nextPage: {}
    }
  },

  beforeRouteLeave (to, from, next) {
    // If the form is dirty and the user did not confirm leave,
    // prevent losing unsaved changes by canceling navigation
    let tempUser = localStorage.getItem('tempUser')
    if (tempUser && tempUser === 'true') {
      this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: 'Cannot move past this page till account setup is complete'
      })
      this.showNewFormPopup()
      this.nextPage = next
    } else {
      // Navigate to next view
      next()
    }
  },

  async mounted () {
    this.resetData()
    await this.loadDataForProgramGuideCareerProspects()
    let tempUser = localStorage.getItem('tempUser')
    if (tempUser && tempUser === 'true') {
      window.addEventListener('contextmenu', (e) => {
        e.preventDefault()
      }, false)
    }
  },

  methods: {
    ...mapActions([
      'loadProgramGuide',
      'loadProgramGuideCareers',
      'loadProgramCareerResult',
      'loadAlumniStreamRecommendations',
      'loadAdvisorStreamRecommendations',
      'resetProgramCareerResult',
      'loadGeoIds',
      'loadLogDashboardActivity',
      'loadPlanningStream',
      'loadProgramCreditProgress',
      'loadFinishAccountSetup',
      'setTemporaryUserToFalse'
    ]),
    addCompletedCourses () {
      return this.$router.push({name: 'selfReportedCourseList'})
    },
    setPrecision (n) {
      if (Number(n) === n && n % 1 !== 0) {
        return 1
      }
      return 0
    },
    async registerProspectiveStudent () {
      if (this.newForm.firstName.length < 1 || this.newForm.lastName.length < 1 || this.newForm.password.length < 1) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'First Name, Last Name and Password are required'
        })
      } else if (this.newForm.password !== this.repassword) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'Passwords do no match'
        })
      } else if (this.isShowPhoneOnCreateAccountModalEnabled && this.isPhoneRequiredOnCreateAccountModal && this.newForm.primaryPhoneNumber.length < 1) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'Phone Number is required'
        })
      } else {
        this.$refs.loadingModal.show()
        await this.loadFinishAccountSetup(this.newForm)
        let bool = false
        this.setTemporaryUserToFalse()
        this.nextPage()
      }
    },
    showNewFormPopup (popupPosition) {
      this.$refs.newFormModal.show()
      $('.usr_verification_popup').removeClass('showAtTop')
      $('.usr_verification_popup').removeClass('showAtBottom')
      $('.usr_verification_popup').addClass('showAtTop')
    },
    closeModalBox () {
      this.$root.$emit('bv::hide::modal', 'userVerificationPopup')
      this.$parent.isShowTagPopup = false
      this.newForm = {
        firstName: '',
        lastName: '',
        password: '',
        primaryPhoneNumber: ''
      }
    },
    async loadDataForProgramGuideCareerProspects () {
      this.showLoader()
      let cipCode = this.cipCode
      let programGuideCode = this.programGuideCode
      let returnTo = this.returnTo && this.returnTo.length ? this.returnTo : this.DEFAULT_RETURN_TO
      if (!cipCode || !programGuideCode) {
        return this.$router.push({ name: returnTo })
      }
      let programGuide = await this.loadProgramGuide({
        cipCode: cipCode,
        programGuideCode: programGuideCode,
        type: this.programGuideType,
        loadDataFromServer: true
      })
      if (!programGuide || !programGuide.cipCode) {
        return this.$router.push({ name: returnTo })
      }
      if (this.isWidget) {
        await this.loadPlanningStream()
      }
      // load cerdit progress
      this.progress = await this.loadProgramCreditProgress({streamId: this.planningStream.uuid, programId: programGuide.uuid, recalculate: false})
      // load related career information, if any exists
      await this.loadProgramGuideCareers({ cipCode: programGuide.cipCode, code: programGuide.code, showAllOccupations: this.showAllOccupations })
      await this.loadGeoIds()
      this.hideLoader()
      this.loadLogDashboardActivity({action: 'viewProgramCareerProspects', page: 'programCareerProspects', link: '', programCipCode: cipCode})
    },
    showLoader () {
      this.$parent.$refs.loadingModal.show()
    },
    hideLoader () {
      this.$parent.$refs.loadingModal.hide()
    },
    goToCareerPage (career) {
      return this.$router.push({ name: 'careerIntroduction', params: { code: career.code, returnTo: this.returnTo } })
    },
    goToStreamPage (stream) {
      // Alumni streams have 'streamId' set, Advisor streams just have uuid
      let uuid = (stream.streamId) ? stream.streamId : stream.uuid
      return this.$router.push({ name: 'streamTime', params: { uuid: uuid } })
    },
    getLocationParamForCareerSearch () {
      let locationParam = ''
      let selectedState = (this.selectedState && this.selectedState.label) ? this.selectedState.label : ''
      let selectedMetroArea = (this.selectedMetroArea && this.selectedMetroArea.label) ? this.selectedMetroArea.label : ''
      let selectedCounty = (this.selectedCounty && this.selectedCounty.label) ? this.selectedCounty.label : ''

      if (selectedState) {
        locationParam = 'state:' + this.labelsToCodesMap.stateGeoIds[selectedState]
      } else if (selectedMetroArea) {
        locationParam = 'msa:' + this.labelsToCodesMap.msaGeoIds[selectedMetroArea]
      } else if (selectedCounty) {
        locationParam = 'county:' + this.labelsToCodesMap.countyGeoIds[selectedCounty]
      }
      return locationParam
    },
    careerSearchClicked () {
      let careerCode = this.formattedCareer.cipCode
      let locationParam = this.getLocationParamForCareerSearch()

      if (!locationParam || !careerCode) {
        return
      }

      this.$refs.loadingModal.show()
      this.loadProgramCareerResult({careerCode: careerCode, locationParam: locationParam}).then(response => {
        this.$refs.loadingModal.hide()
        if (!response) {
          this.$notify({
            group: 'notify',
            type: 'warning',
            title: '',
            text: 'Career search returned zero results.'
          })
        }
        this.$forceUpdate()
      })
    },
    addCommaInNumber (numValue) {
      return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    updateClassOnPageScroll () {
      let contentContainerScrollPosition = $('#careerProspectsPgContent').scrollTop()
      let contentContainerWidth = $('.content_mid_panel').width()
      if (contentContainerScrollPosition > 230) {
        $('#careerProspectsPgContent').addClass('fix_pg_tabs')
        $('.fix_pg_tabs .tabs').width(contentContainerWidth - 2)
        $('.fix_pg_tabs .tabs_separator').width(contentContainerWidth + 30)
        $('.fix_pg_tabs .filters_section').width(contentContainerWidth - 15)
        $('.fix_pg_tabs .floating_filter_container').css('left', contentContainerWidth + 230)
        $('.filters_section').css('display', 'none')
      } else {
        $('#careerProspectsPgContent').removeClass('fix_pg_tabs')
        $('.filters_section').width('auto')
        $('.filters_section').css('display', 'block')
      }
    },
    formatOptionsForVSelect (map) {
      let formatted = []
      Object.keys(map).sort().forEach((key, i) => {
        formatted.push({id: key, label: map[key]})
      })
      return formatted
    },
    setDotMargin (positionValue) {
      let getXPosition = (120000 - positionValue) / 100
      return getXPosition + 'px'
    },
    resetData () {
      // this ensures the original program guide object info binds to the ui
      this.targetOccupationItems = []
      this.topCompaniesItems = []
      this.topSkillsItems = []
      this.resetProgramCareerResult()
    },
    returnToClicked () {
      if (this.returnTo === 'relatedPrograms') {
        let routerParams = JSON.parse(localStore.getItem('returnRouterParams'))
        localStore.removeItem('returnRouterParams')
        return this.$router.push({ name: 'programGuideRelatedProgram', params: routerParams, query: {returnTo: routerParams.returnTo} })
      }
      return this.$router.push({ name: this.returnTo })
    },
    deCamelCase () {
      if (!this.returnTo) {
        this.returnTo = this.DEFAULT_RETURN_TO
      }
      if (this.returnTo === this.EXPLORE_RESULTS) {
        return 'return to all results'
      }
      let result = this.returnTo.replace(/([A-Z])/g, ' $1')
      return 'return to ' + result
    },
    parseTerms (sourceList) {
      if (!sourceList || !sourceList.length) {
        return
      }
      let targetList = []
      let TERM_LIMIT = this.RECOMMENDATION_TERM_LIMIT
      sourceList.forEach((item, i) => {
        if (i < TERM_LIMIT) {
          let curr = JSON.parse(item)
          targetList.push(curr.name)
        }
      })
      return targetList
    },
    buildAlumniStreamRecommendationData (programGuide, careerInfo) {
      let data = {
        'cipCode': programGuide.cipCode,
        'title': programGuide.title,
        'targetOccupations': [],
        'topCompanies': [],
        'topSkills': []
      }

      if (!careerInfo) {
        return data
      }

      data.targetOccupations = this.parseTerms(careerInfo.targetOccupations)
      data.topCompanies = this.parseTerms(careerInfo.topPostingCompanies)
      data.topSkills = this.parseTerms(careerInfo.topSkills)
      return data
    },
    getCoursePlanningPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getCoursePlanningPackage(packages)
    },
    hasLaborData (career) {
      if (!career) {
        return false
      }
      return career.targetOccupations || career.topPostingCompanies || career.topSkills
    },
    calculateCreditProgressClicked (programGuide) {
      this.selectedProgramGuide = programGuide
      this.creditProgressTargetId = 'creditProgressPopup_' + programGuide.uuid
      this.showCreditProgressPopup = true
    },
    getExploreSearchPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getExploreSearchPackage(packages)
    }
  },
  computed: {
    ...mapState({
      'programGuide': state => state.programguide.programGuideObject,
      'showAllOccupations': state => state.programguide.showAllOccupations,
      'careersObject': state => state.programguide.careers,
      'careerResult': state => state.programguide.careerResult,
      'packages': state => state.institution.packages,
      'institution': state => state.institution.institution,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'geoIdMap': state => state.career.geoIdMap,
      'planningStream': state => state.dashboard.planningStream
    }),
    formattedProgramGuide () {
      let formattedProgramGuide = this.programGuide
      return formattedProgramGuide
    },
    formattedCareers () {
      let formattedCareers = []
      let careers = this.careersObject
      if (!this.hasLaborData(careers)) {
        return []
      }
      careers.targetOccupations.forEach((career) => {
        formattedCareers.push(JSON.parse(career))
      })
      return formattedCareers
    },
    formattedCareer () {
      let formattedCareer = (this.careerResult && this.careerResult.uuid) ? this.careerResult : this.careersObject
      if (!this.hasLaborData(formattedCareer)) {
        return {}
      }
      this.resetData()
      formattedCareer.targetOccupations.forEach((career, i) => {
        let curr = JSON.parse(career)
        if (i === 0) {
          formattedCareer.timeframe = curr.timeframe
          formattedCareer.endYear = curr.year
          formattedCareer.startYear = formattedCareer.endYear - 10
          formattedCareer.tenYearOldJobTitle = curr.tenYearOldJobTitle
        }
        let tenYearOldJobTitle = formattedCareer.tenYearOldJobTitle
        let growthTitle = 'Growth (' + formattedCareer.timeframe + ')'
        let currItem = {
          'Occupation': curr.name,
          'Annual Openings': curr.annualOpening,
          'Median Earnings': curr.medianHourlyEarning
        }
        currItem[tenYearOldJobTitle] = curr.tenYearOldJob
        currItem[growthTitle] = curr.growth
        this.targetOccupationItems.push(currItem)
      })

      if (!formattedCareer.topPostingCompanies) {
        return formattedCareer
      }

      formattedCareer.topPostingCompanies.forEach((company, i) => {
        let curr = JSON.parse(company)
        let tenYearPostingTitle = 'Total/Unique (' + formattedCareer.timeframe + ')'
        let currItem = {'Company': curr.name}
        currItem[tenYearPostingTitle] = curr.total_postings + ' / ' + curr.unique_postings
        currItem['Posting Intensity'] = (Math.round(curr.posting_intensity)) + ':1'
        this.topCompaniesItems.push(currItem)
      })

      if (!formattedCareer.topSkills) {
        return formattedCareer
      }

      formattedCareer.topSkills.forEach((skill, i) => {
        let curr = JSON.parse(skill)
        let currItem = {'Skill': curr.name, 'Postings with Skill': curr.unique_postings}
        this.topSkillsItems.push(currItem)
      })
      return formattedCareer
    },
    formattedGeoIdMap () {
      let formattedMap = {}
      let map = this.geoIdMap

      if (map.stateGeoIds && map.msaGeoIds && map.countyGeoIds) {
        formattedMap.stateGeoIds = this.formatOptionsForVSelect(map.stateGeoIds)
        formattedMap.msaGeoIds = this.formatOptionsForVSelect(map.msaGeoIds)
        formattedMap.countyGeoIds = this.formatOptionsForVSelect(map.countyGeoIds)
      }
      return formattedMap
    },
    labelsToCodesMap () {
      let map = this.geoIdMap
      let formattedMap = {}
      if (map.stateGeoIds && map.msaGeoIds && map.countyGeoIds) {
        formattedMap.stateGeoIds = _.invert(map.stateGeoIds)
        formattedMap.msaGeoIds = _.invert(map.msaGeoIds)
        formattedMap.countyGeoIds = _.invert(map.countyGeoIds)
      }
      return formattedMap
    },
    targetOccupationFields () {
      let fields = ['Occupation']
      if (this.formattedCareer.targetOccupations && this.formattedCareer.targetOccupations.length > 0) {
        let curr = JSON.parse(this.formattedCareer.targetOccupations[0])
        fields.push((curr.tenYearOldJobTitle))
        fields.push('Annual Openings')
        fields.push('Median Earnings')
        fields.push('Growth (' + curr.timeframe + ')')
        return fields
      } else {
        return []
      }
    },
    topCompaniesFields () {
      let fields = ['Company']
      if (this.formattedCareer.targetOccupations && this.formattedCareer.targetOccupations.length > 0) {
        let curr = JSON.parse(this.formattedCareer.targetOccupations[0])
        fields.push('Total/Unique (' + curr.timeframe + ')')
        fields.push('Posting Intensity')
        return fields
      } else {
        return []
      }
    },
    recommendationFeatureMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
      let coursePlanningPackage = this.getCoursePlanningPackage()
      return PackageUtil.getFeatureFromPackage(coursePlanningPackage, featureId)
    },
    recommendationFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
      let coursePlanningPackage = this.getCoursePlanningPackage()
      return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
    },
    showRecommendationsTab () {
      return this.isRecommendationFeatureEnabled && (this.isAlumniStreamRecommendationsEnabled || this.isAdvisorStreamRecommendationsEnabled)
    },
    isRecommendationFeatureEnabled () {
      return this.recommendationFeatureMap.enabled
    },
    isAlumniStreamRecommendationsEnabled () {
      return this.recommendationFlagMap.showAlumniStreamRecommendations.enabled
    },
    isAdvisorStreamRecommendationsEnabled () {
      return this.recommendationFlagMap.showAdvisorStreamRecommendations.enabled
    },
    programGuideType () {
      let programGuideType = this.type
      if (!programGuideType || !programGuideType.length || programGuideType.length <= 0) {
        programGuideType = this.DEFAULT_TYPE
      }
      return programGuideType
    },
    formattedSelectedConcentration () {
      let selectedConcentration = this.selectedConcentration
      if (!selectedConcentration) {
        return {}
      }
      return selectedConcentration
    },
    showConcentrationsTab () {
      let formattedProgramGuide = this.formattedProgramGuide
      if (!formattedProgramGuide || !formattedProgramGuide.concentrationProgramGuides) {
        return false
      }
      let numberOfConcentrations = formattedProgramGuide.concentrationProgramGuides.length
      return numberOfConcentrations > 0
    },
    showAddCompletedCoursesOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultAddCompletedCourses) {
        return false
      }
      return exploreProgramsFlagMap.searchResultAddCompletedCourses.enabled
    },
    showTransferredCoursesCreditProgress () {
      let transferCoursesFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.TRANSFER_PREVIOUS_COURSES_FEATURE_ID]
      if (transferCoursesFeature && transferCoursesFeature.enabled) {
        let flags = transferCoursesFeature.flags
        for (let i = 0; i < flags.length; i++) {
          let flag = flags[i]
          if (flag.title === 'showTransferredCoursesCreditProgress') {
            return flag.enabled
          }
        }
      }
      return false
    },
    showCalculateRequiredCredit () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultCalculateRequiredCredit) {
        return false
      }
      return exploreProgramsFlagMap.searchResultCalculateRequiredCredit.enabled
    },
    isShowCourseProgressEnabled () {
      let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
      if (progressViewFeature && progressViewFeature.enabled) {
        let flags = progressViewFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showCourseProgress' || flags[i].title === 'showCourseProgressOnOverall') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isShowCreditProgressEnabled () {
      let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
      if (progressViewFeature && progressViewFeature.enabled) {
        let flags = progressViewFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showCreditProgress') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isStudentLogin () {
      return (localStorage.getItem('userrole') === 'Student')
    },
    exploreProgramsFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },
    showPhoneOnCreateAccountModalLabel () {
     let showPhoneFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_PHONE_NUMBER_ON_CREATE_ACCOUNT]
     return showPhoneFeature.label
    },
    isShowPhoneOnCreateAccountModalEnabled () {
     let showPhoneFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_PHONE_NUMBER_ON_CREATE_ACCOUNT]
     return showPhoneFeature && showPhoneFeature.enabled
    },
    isPhoneRequiredOnCreateAccountModal () {
     let showPhoneFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_PHONE_NUMBER_ON_CREATE_ACCOUNT]
     for (var i = 0; i < showPhoneFeature.flags.length; i++) {
       if (showPhoneFeature.flags[i].title === 'phoneNumberRequired') {
         return showPhoneFeature.flags[i].enabled
       }
     }
     return false
    },
  },
  watch: {
    showAllOccupations (newShowAllOccupations) {
      this.loadDataForProgramGuideCareerProspects()
    },
    selectedState (newState) {
      if (!newState) {
        this.disableSelectState = false
        this.disableSelectMetroArea = false
        this.disableSelectCounty = false
      } else {
        this.disableSelectState = false
        this.disableSelectMetroArea = true
        this.disableSelectCounty = true
      }
    },
    selectedMetroArea (newMSA) {
      if (!newMSA) {
        this.disableSelectState = false
        this.disableSelectMetroArea = false
        this.disableSelectCounty = false
      } else {
        this.disableSelectState = true
        this.disableSelectMetroArea = false
        this.disableSelectCounty = true
      }
    },
    selectedCounty (newCounty) {
      if (!newCounty) {
        this.disableSelectState = false
        this.disableSelectMetroArea = false
        this.disableSelectCounty = false
      } else {
        this.disableSelectState = true
        this.disableSelectMetroArea = true
        this.disableSelectCounty = false
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideCareerProspects.vue